import { render, staticRenderFns } from "./ModalConfiguracaoAlmoxarifado.vue?vue&type=template&id=a9d71c6e"
import script from "./ModalConfiguracaoAlmoxarifado.vue?vue&type=script&lang=js"
export * from "./ModalConfiguracaoAlmoxarifado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports